import moment from 'moment';
import { AfterViewInit, Component, ElementRef, EventEmitter, OnInit, Output, TemplateRef, ViewChild, HostListener } from '@angular/core';
import { debounceTime, firstValueFrom, fromEvent, Subscription } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { getUserClaim, USER_PROFILE } from '@shared/service/constants.services';
import { ApolloSchoolService } from '@core/graphql/apolloSchool.service';
import { ApolloUserService } from '@core/graphql/apolloUser.service';
import { jwtDecode } from 'jwt-decode';
import { SharedService } from '@shared/service/sharedservice';
import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {
  userDetail: any;
  userClaim: any;
  userId: any;
  selectedYear: number = new Date().getFullYear();
  @Output() displayChange = new EventEmitter<boolean>();
  isDisplayed: boolean = false;
  show?: boolean;
  accordionTodayNoti: any;
  accordionYesterdayNoti: any;
  accordionLastWeekNoti: any;
  accordionOlderNoti: any;
  todayNoti: any = [];
  yesterdayNoti: any = [];
  lastWeekNoti: any = [];
  olderNoti: any = [];
  allNoti: any;
  param: any;
  notiStateEmptyOrNot: boolean = true;
  userForm!: FormGroup;
  schoolYearList: any[] = [];
  submitted = false;

  notiCount!: { all: number, unread: number, read: number };
  private todayNotiTemplateSub!: Subscription;
  private yesterdayNotiTemplateSub!: Subscription;
  private lastWeekNotiTemplateSub!: Subscription;
  private olderNotiItemsSub!: Subscription;

  @ViewChild('todayNotiItems', { static: false }) todayNotiTemplate!: ElementRef;
  @ViewChild('yesterdayNotiItems', { static: false }) yesterdayNotiTemplate!: ElementRef;
  @ViewChild('lastWeekNotiItems', { static: false }) lastWeekNotiTemplate!: ElementRef;
  @ViewChild('olderNotiItems', { static: false }) olderNotiItems!: ElementRef;

  isOutsideWorkingHour: boolean = true;
  isCheckin: boolean = false;
  isCheckout: boolean = false;
  isUserCheckInDetail: any;
  isSupportUser: boolean = false;
  isUserHasShift: boolean = false;
  alertProperties = { type: '', message: '' }
  showAlert: boolean = false;
  shiftUserRoleDetail: any;
  isUserCheckedIn: boolean = false;
  currentUser: any;
  isDisplayAfterCheckin: boolean = false;
  mobileMenuItems: any[] = []; // Declare the property here
  isMobileMenuOpen: boolean = false;
  isMobile: boolean = false;

  modalTemplate: any = {};
  modalState!: boolean;
  modalSize: any = {};
  modalOptions: any = {};
  loading: boolean = false;

  userRoles: any[] = [];
  currentRole: string = 'Admin'; // Default to Admin
  switchToRole: string = 'Parent'; // Default switch role
  hasParentRoleWithSwitch: boolean = false;
  hasStaffRole: boolean = false;
  isCheckedIn: boolean = false;
  staffNotCheckInList: any[] = [];
  checkedInUsers: any[] = [];

  selectedSchool: string = '';
  schoolList: string[] = [];
  profileImageBase64: string = '';

  @ViewChild('headerPopup', { static: true })
  headerPopup!: TemplateRef<object>;

  constructor(private formBuilder: FormBuilder, private router: Router, private schoolService: ApolloSchoolService, private shareService: SharedService, private userService: ApolloUserService,
    private cdr: ChangeDetectorRef) {
    this.refreshUserClaim();
  }

  ngOnInit() {
    this.refreshUserClaim();
    this.getSchoolYearList();
    this.initForm();
    this.loadRoles();
    this.checkIsMobile();
    this.loadProfile();
    this.shareService.menuItems$.subscribe((menuItems) => {
      this.mobileMenuItems = menuItems;
    });
    this.getStaffNotCheckInList();
    this.shareService.setStaffCheckedIn(this.isCheckedIn);
    this.getCheckedInUsers();

    this.isCheckedIn = this.shareService.getStaffCheckedIn();
  }

  loadProfile() {
    const userProfile = localStorage.getItem("userProfile");
    if (userProfile) {
      const parsedProfile = JSON.parse(userProfile);
      this.userId = parsedProfile.id;
      if (this.userId) {
        this.userDetail = null;
        this.getUserById(this.userId);
      }
    } else {
      this.router.navigate(['/login']);
    }
  }

  get profileLink(): string {
    return this.shareService.buildRoleBasedUrl('myprofile');
  }

  getUserById(id: any) {
    this.userService.getUserById(id).subscribe({
      next: (result: any) => {
        this.userDetail = result;
        if (result.profilePictureBase64) {
          this.profileImageBase64 = `data:image/png;base64,${result.profilePictureBase64}`;
        } else {
          this.profileImageBase64 = 'assets/images/user-profile.jpg';
        }
      }
    });
  }

  loadRoles() {
    const rolesString = localStorage.getItem('userRoles');
    if (!rolesString) {
      return;
    }

    this.userRoles = JSON.parse(rolesString);

    const adminRole = this.userRoles.find((role) => role.name === 'Admin');
    const parentRole = this.userRoles.find((role) => role.name === 'Parent');
    const staffRole = this.userRoles.find((role) => role.name === 'Staff');

    this.hasStaffRole = !!staffRole;

    const availableRoles: string[] = [];
    if (adminRole) {
      availableRoles.push('Admin');
    }
    if (parentRole) {
      availableRoles.push('Parent');
    }
    if (staffRole) {
      availableRoles.push('Staff');
    }

    const storedRole = this.shareService.getActiveRole();
    const preferredRole = availableRoles.includes(storedRole) ? storedRole : (availableRoles[0] ?? 'Admin');
    this.currentRole = preferredRole;

    const nonParentRole = availableRoles.find(role => role !== 'Parent');
    this.hasParentRoleWithSwitch = !!parentRole && !!nonParentRole;

    if (this.hasParentRoleWithSwitch) {
      this.switchToRole = this.currentRole === 'Parent' ? (nonParentRole ?? 'Admin') : 'Parent';
    } else if (availableRoles.length > 1) {
      this.switchToRole = availableRoles.find(role => role !== this.currentRole) ?? this.currentRole;
    } else {
      this.switchToRole = this.currentRole;
    }
  }

  toggleRole(): void {
    const previousRole = this.currentRole;
    this.currentRole = this.switchToRole;
    this.switchToRole = previousRole;

    // Update activeRole in localStorage via RoleService
    this.shareService.setCurrentRole(this.currentRole);

    // Redirect based on the current role
    if (this.currentRole === 'Parent') {
      this.shareService.showCard(true);
      this.router.navigate([this.shareService.buildRoleBasedUrl('mykids')]);
      return;
    }

    this.shareService.showCard(false);
    const targetPath = this.currentRole === 'Staff' ? 'staffCheckIn' : 'user/listing';
    const queryParams = this.currentRole === 'Admin' ? { tab: 'user' } : undefined;
    const targetUrl = this.shareService.buildRoleBasedUrl(targetPath);

    if (queryParams) {
      this.router.navigate([targetUrl], { queryParams });
    } else {
      this.router.navigate([targetUrl]);
    }
  }

  toggleMobileMenu(): void {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
    // Close all submenus
    this.mobileMenuItems.forEach(menuItem => menuItem.showSubmenu = false);
  }

  setActiveMenuItem(item: any) {
    this.mobileMenuItems.forEach(menuItem => menuItem.showSubmenu = false);

    if (item.isExternal) {
      window.location.href = item.link;
    } else {
      const extras = item.queryParams ? { queryParams: item.queryParams } : undefined;
      if (extras) {
        this.router.navigate([item.link], extras);
      } else {
        this.router.navigate([item.link]);
      }
    }

    this.isMobileMenuOpen = false;
  }

  private refreshUserClaim(): void {
    this.userClaim = getUserClaim();
    const currentYear = new Date().getFullYear();
    const claimYear = Number(this.userClaim?.SchoolYear ?? (this.userClaim as any)?.schoolYear);
    this.selectedYear = Number.isFinite(claimYear) && claimYear > 0 ? claimYear : currentYear;
    this.shareService.setSelectedYear(this.selectedYear);
  }

  initForm() {
    this.userForm = this.formBuilder.group({
      year: [this.selectedYear, Validators.required],
    });
  }

  showPanel() {
    if (this.show)
      this.show = false;
    else
      this.show = true;
  }

  @HostListener('window:resize', [])
  onResize() {
    this.checkIsMobile();
  }

  checkIsMobile() {
    this.isMobile = window.innerWidth <= 767;
  }

  activeTab(id: string) {
    document.getElementById("allNoti")?.classList.remove("noti-tab", "active-btn");
    document.getElementById("unreadNoti")?.classList.remove("noti-tab", "active-btn");
    document.getElementById("readNoti")?.classList.remove("noti-tab", "active-btn");
    document.getElementById(id)?.classList.add("noti-tab", "active-btn");

    // if (id === "allNoti")
    //   this.notiTypeClicked(1)
    // if (id === "unreadNoti")
    //   this.notiTypeClicked(2)
    // if (id === "readNoti")
    //   this.notiTypeClicked(3)
  }

  getSchoolYearList() {
    this.schoolService.getSchoolYearList().subscribe({
      next: (result: any) => {
        this.schoolYearList = (Array.isArray(result) ? result : [])
          .filter((sy: any) => Number.isFinite(Number(sy?.year)))
          .sort((a: any, b: any) => Number(b.year) - Number(a.year));
        const currentYear = new Date().getFullYear();
        this.selectedYear = this.selectedYear || currentYear;

        this.schoolList = this.schoolYearList
          .filter(sy => sy.year === this.selectedYear)
          .map(sy => sy.school?.name || "No School");

        this.userForm.patchValue({ year: this.selectedYear });
      },
      error: (error) => {
        this.displayAlert("danger", "Failed to fetch school year list.");
      }
    });
  }

  onChangeYear(value: any) {
    const formValue = this.userForm.value;
    const userInput = {
      year: formValue.year
    };

    this.schoolList = this.schoolYearList
      .filter(sy => sy.year === userInput.year)
      .map(sy => sy.school?.name || "No School");

    this.loading = true;
    this.schoolService.updateSchoolYearClaim(userInput).subscribe(
      (response) => {
        if (response.success) {
          var decodedToken = jwtDecode(response.success);
          localStorage.setItem("userClaim", JSON.stringify(decodedToken));
          localStorage.setItem("userSecret", response.success);

          setTimeout(() => {
            this.loading = false;
            window.location.reload();
          }, 2000);
          this.displayAlert("success", "Selected School Year is now changed to " + value.year);
        } else {
          this.displayAlert("danger", response.error);
        }
      },
      (error) => {
        this.loading = false;
        this.displayAlert("danger", "Failed to Change School Year");
      }
    );
  }

  signOut() {
    this.loading = true;
    localStorage.clear();
    this.shareService.setCurrentRole('');
    this.shareService.setStaffCheckedIn(false);
    localStorage.removeItem('userProfile');
    localStorage.removeItem('userClaim');
    localStorage.removeItem('userSecret');
    localStorage.removeItem('userRoles');
    localStorage.removeItem('userAccess');
    this.router.navigate(['/login'], { replaceUrl: true });
    this.loading = false;
  }

  applySelectedSchool(): void {
    if (this.selectedSchool) {
      console.log('Selected School:', this.selectedSchool);
      this.displayAlert('success', `Switched to ${this.selectedSchool}`);
    } else {
      this.displayAlert('danger', 'Please select a school to apply.');
    }
  }

  getStaffNotCheckInList(rangeDate?: any) {
    if (!rangeDate) {
      const today = new Date();
      rangeDate = {
        startDate: today.toISOString().split("T")[0],
        endDate: today.toISOString().split("T")[0]
      };
    }

    this.loading = true;
    this.userService.getStaffNotCheckInList(rangeDate.startDate, rangeDate.endDate).subscribe({
      next: (result: any) => {
        this.staffNotCheckInList = result.map((i: any) => {
          const staffRole = i.userRoles?.find((role: any) => role.refRole.name === "Staff");
          return {
            id: i.id,
            fullName: i.firstName + " " + i.lastName,
            userRoleId: staffRole ? Number(staffRole.id) : null,
          };
        });

        this.cdr.detectChanges();

        this.loading = false;
      },
      error: (error) => {
        this.loading = false;
        this.displayAlert("danger", "Failed to Fetch Data");
      }
    });
  }

  getCheckedInUsers(rangeDate?: any) {
    const today = new Date();
    rangeDate = {
      startDate: today.toISOString().split("T")[0],
      endDate: today.toISOString().split("T")[0]
    };

    this.loading = true;
    this.userService.getCheckInOutList(rangeDate.startDate, rangeDate.endDate).subscribe({
      next: (result: any) => {
        const storedRole = JSON.parse(localStorage.getItem('staffUserRoleId') || '0');
        const staffUserRoleId = Number(storedRole);
        this.checkedInUsers = result.filter((user: any) => !user.checkOutDateTime);
        const hasActiveCheckIn = this.checkedInUsers.some((user: any) => Number(user.userRole?.id) === staffUserRoleId);
        this.isCheckedIn = !!hasActiveCheckIn;
        this.shareService.setStaffCheckedIn(this.isCheckedIn);
        this.cdr.detectChanges();
        this.loading = false;
      },
      error: (error) => {
        this.loading = false;
        this.displayAlert("danger", "Failed to Fetch Checked-In Users");
      }
    });
  }

  async staffCheckIn(): Promise<void> {
    const storedRole = JSON.parse(localStorage.getItem('staffUserRoleId') || '0');
    const staffUserRoleId = Number(storedRole);
    this.loading = true;

    if (this.isCheckedIn) {
      const checkInRecord = await this.resolveActiveStaffCheckInRecord(staffUserRoleId);
      if (!checkInRecord) {
        this.loading = false;
        this.displayAlert('danger', 'Unable to locate an active staff check-in record. Please refresh and try again.');
        return;
      }

      const userInput = {
        id: checkInRecord.id,
        attachmentName: "",
        attachmentBase64: "",
        attachmentType: ""
      };
      this.userService.createCheckOut(userInput).subscribe(
        (response) => {
          this.loading = false;
          if (response.success && response.success !== "") {
            this.isCheckedIn = false;
            this.displayAlert('success', 'Successfully checked out.');
            this.shareService.setStaffCheckedIn(this.isCheckedIn);
            this.checkedInUsers = [];
            this.cdr.detectChanges();
          } else {
            this.displayAlert("danger", response.error);
          }
        },
        (error) => {
          this.loading = false;
          this.displayAlert("danger", "Failed to create Staff Check-Out");
        }
      );
    } else {
      const userInput = {
        staffUserRoleId: staffUserRoleId,
        attachmentName: "",
        attachmentBase64: "",
        attachmentType: ""
      };
          this.userService.createCheckIn(userInput).subscribe(
            (response) => {
              this.loading = false;
              if (response.success && response.success !== "") {
                const fullName = `${this.userDetail.firstName} ${this.userDetail.lastName}`;
                this.isCheckedIn = true;
                this.displayAlert('success', `Successfully checked in for ${fullName}`);
                this.router.navigate([this.shareService.buildRoleBasedUrl('student/listing')], {
                  queryParams: { tab: 'checkin' }
                });
                this.shareService.setStaffCheckedIn(this.isCheckedIn);
                this.cdr.detectChanges();
              } else {
                this.displayAlert("danger", response.error);
              }
            },
        (error) => {
          this.loading = false;
          this.displayAlert("danger", "Failed to create Staff Check-In");
        }
      );
    }

    this.cdr.detectChanges();
  }

  private async resolveActiveStaffCheckInRecord(staffUserRoleId: number): Promise<any | null> {
    const localRecord = this.checkedInUsers.find((user: any) => Number(user.userRole?.id) === staffUserRoleId);
    if (localRecord) {
      return localRecord;
    }

    const today = new Date().toISOString().split("T")[0];
    try {
      const records = await firstValueFrom(this.userService.getCheckInOutList(today, today));
      return records.find((user: any) => !user.checkOutDateTime && Number(user.userRole?.id) === staffUserRoleId) ?? null;
    } catch {
      return null;
    }
  }

  displayAlert(type: string, message: string) {
    this.showAlert = true;
    this.alertProperties = { type: type, message: message }
    window.setTimeout(() => {
      this.showAlert = false;
    }, 5000)
  }
}
